import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { seriesItems } from "@/mocks/digData";

const statusStyle: Record<string, string> = {
  持续更新: "bg-primary-100 text-primary-800",
  接近尾声: "bg-secondary-100 text-secondary-900",
  已定档结局: "bg-accent-100 text-accent-900",
};

export default function SeriesSection() {
  const [expandedId, setExpandedId] = useState<string | null>(seriesItems[0]?.id ?? null);

  return (
    <section id="series" className="scroll-mt-24 py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="SERIES BOARD"
          title="热门吃瓜连续剧 · 按剧情线追"
          desc="我们不按时间堆新闻，而是按「事件线」聚合内容。每条连续剧都有集数、状态与看点标签，点开就能看它现在演到哪一集。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seriesItems.map((item) => {
            const expanded = expandedId === item.id;
            return (
              <article
                key={item.id}
                className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
              >
                <div className="relative w-full h-48 md:h-52">
                  <img
                    src={item.cover}
                    alt={item.coverAlt}
                    className="w-full h-full object-cover object-top"
                  />
                  <span
                    className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${
                      statusStyle[item.status]
                    }`}
                  >
                    {item.status}
                  </span>
                  <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-foreground-950/70 text-background-50 text-xs backdrop-blur-sm">
                    <i className="ri-play-list-2-line" />
                    第 {item.episodes} 集
                  </span>
                </div>

                <div className="flex flex-col flex-1 p-4 md:p-5">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-900"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">
                    {item.summary}
                  </p>

                  {expanded && (
                    <div className="mt-4 rounded-md border border-background-200 bg-background-100 p-3 text-sm text-foreground-700">
                      <p className="flex items-center gap-1.5 font-medium text-foreground-900">
                        <i className="ri-eye-line text-primary-600" />
                        当前看点
                      </p>
                      <p className="mt-1.5 leading-relaxed">
                        最近一集聚焦「{item.tags[0]}」，双方说法仍在更新，完整脉络见时间线对应条目。
                      </p>
                    </div>
                  )}

                  <div className="mt-4 flex items-center justify-between gap-3">
                    <span className="inline-flex items-center gap-1 text-sm text-primary-600">
                      <i className="ri-fire-line" />
                      {item.heat}
                    </span>
                    <button
                      type="button"
                      aria-expanded={expanded}
                      onClick={() => setExpandedId(expanded ? null : item.id)}
                      className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer"
                    >
                      {expanded ? "收起看点" : "展开看点"}
                      <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}